import { createReducer } from 'cdpro-redux-utils'

import { RootState } from './types'
import { setWelcomeMessage } from './actions'
import * as Actions from './actions'

export const INITIAL_STATE: RootState = {
  message: 'Ready to start developing!',
  firstAccess: false,
  userAccount: '',
  cpf: '',
  cel: '',
  version: '',
  eye: undefined,
  appType: '',
  accountType: 'PESSOA_NATURAL',
  isDarkMode: false,
  isAppPF: false,
  mobilePlatform: undefined,
  isAppPJ: false,
  homeCreditOnboarding: undefined,
  apiRequest: undefined,
  skeleton: undefined,
  globalBottomSheet: {
    isOpen: false,
    title: undefined,
    expansible: 'on',
    position: 'hug',
    components: [],
  },
}

const { reducer, addCase } = createReducer<RootState>(INITIAL_STATE)

addCase(setWelcomeMessage, (draft, action) => {
  const { message } = action.payload

  draft.message = message
})
addCase(Actions.setHomeCreditOnboarding, (draft, action) => {
  draft.homeCreditOnboarding = action.payload.homeCreditOnboarding
})

addCase(Actions.setAppType, (draft, action) => {
  draft.appType = action.payload.appType
})
addCase(Actions.setDarkMode, (draft, action) => {
  draft.isDarkMode = action.payload.isDarkMode
})

addCase(Actions.setMobilePlatform, (draft, action) => {
  draft.mobilePlatform = action.payload
})

addCase(Actions.setUserAccount, (draft, action) => {
  draft.userAccount = action.payload.account
})

addCase(Actions.setUserCel, (draft, action) => {
  draft.cel = action.payload.cel
})

addCase(Actions.setApiRequest, (draft, action) => {
  draft.apiRequest = action.payload.apiRequest
})

addCase(Actions.setSkeleton, (draft, action) => {
  draft.skeleton = action.payload.skeleton
})

addCase(Actions.openGlobalBottomSheet, (draft, action) => {
  draft.globalBottomSheet = {
    isOpen: true,
    title: action.payload.title,
    expansible: action.payload.expansible ?? 'on',
    position: action.payload.position ?? 'hug',
    components: action.payload.components ?? [],
  }
})

addCase(Actions.closeGlobalBottomSheet, (draft) => {
  draft.globalBottomSheet = {
    ...draft.globalBottomSheet,
    isOpen: false,
  }
})

export default reducer
